import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    LocalStorageService,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { menuRoles } from './core/constants/roles';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGIN = environment.URL_LOGIN;
    URL_LOGOUT = environment.URL_LOGOUT;

    menuItens: IMenu[] = [
        {
            label: '',
            roles: menuRoles.itensMenu.home.roles,
            itens: [
                {
                    label: 'Home',
                    icone: 'home',
                    link: '/',
                    roles: Object.values(menuRoles.itensMenu.home.home).flat()
                }
            ]
        },
        {
            label: 'Cadastros',
            roles: menuRoles.itensMenu.cracha.roles,
            itens: [
                {
                    label: 'Crachá',
                    icone: 'badge',
                    link: '/cracha',
                    roles: Object.values(menuRoles.itensMenu.cracha.cracha).flat()
                }
            ]
        },
        {
            label: 'Parametrizações',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Tipo Crachá',
                    icone: 'settings',
                    link: '/tipocracha',
                    roles: Object.values(menuRoles.itensMenu.parametros.tipoCracha).flat()
                },
                {
                    label: 'Tipo Contratação',
                    icone: 'settings',
                    link: '/tipocontratacao',
                    roles: Object.values(menuRoles.itensMenu.parametros.tipoContratacao).flat()
                },
                {
                    label: 'Multa Crachá',
                    icone: 'settings',
                    link: '/multacracha',
                    roles: Object.values(menuRoles.itensMenu.parametros.multaCracha).flat()
                }
            ]
        },
        {
            label: 'Relatório',
            roles: menuRoles.itensMenu.cracha.roles,
            itens: [
                {
                    label: 'Crachá',
                    icone: 'badge',
                    link: '/relatorio-cracha',
                    roles: Object.values(menuRoles.itensMenu.cracha.cracha).flat()
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoesService: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService
    ) {
        if (!environment.USE_BACKEND) {
            _localStorage.setItem('appToken', 'teste');
            _permissoesService.registrarPermissoes(['TESTE_VISUALIZAR']);
        }
        _permissoesService.initPermissoes();
    }

    async logout(event: boolean) {
        if (event) {
            try {
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete(environment.ACCESS_TOKEN, '/', domain);
        this._cookie.delete(environment.REFRESH_TOKEN, '/', domain);
    }
}
